module.exports = require("uuid/v1");